export default {
  meta: {
    title: '选择加盟商',
    url: '/standardstore/index', // 埋点字段，上报归属的模块
    urlName: '拓店任务' // 埋点字段，上报归属的模块
  }
};
